module.exports = __webpack_public_path__ + "static/media/sl.ba135116.svg";